interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  center?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ size = 'md', center = true }) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-4',
    lg: 'w-16 h-16 border-8',
  };

  return (
    <div className={center ? 'flex justify-center' : ''}>
      <div className={`spinner-border animate-spin inline-block ${sizeClasses[size]} rounded-full border-t-primary`} />
    </div>
  );
};

export default Loader;
